/* global global */
import Model from '../Model';

var data = {};

export var SharedModel = (function (Model) {
	function SharedModel ( value, name ) {
		Model.call( this, null, ("@" + name) );
		this.key = "@" + name;
		this.value = value;
		this.isRoot = true;
		this.root = this;
		this.adaptors = [];
	}

	if ( Model ) SharedModel.__proto__ = Model;
	SharedModel.prototype = Object.create( Model && Model.prototype );
	SharedModel.prototype.constructor = SharedModel;

	SharedModel.prototype.getKeypath = function getKeypath () {
		return this.key;
	};

	return SharedModel;
}(Model));

export default new SharedModel( data, 'shared' );

export var GlobalModel = new SharedModel( typeof global !== 'undefined' ? global : window, 'global' );

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/model/specials/SharedModel.js.map
